
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function Home() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [navigate, isAuthenticated, isLoading]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="flex items-center justify-center space-x-3 mb-4">
          <img
            src="https://public.readdy.ai/ai/img_res/a767d65d-0e19-49c9-9380-a6816d196f72.png"
            alt="PoolChem Logo"
            className="w-12 h-12 object-contain"
          />
          <span className="text-2xl font-bold text-teal-600">PoolChem Monitor</span>
        </div>
        <p className="text-gray-600">Redirigiendo...</p>
      </div>
    </div>
  );
}
